module.exports = __webpack_public_path__ + "static/img/bank.7c642be6.png";